import React from 'react';
import AuthBox from '../../../../Containers/Auth/AuthBox'
import styles from './index.module.scss'

const LoginLogoutBox = () => {
    return (
        <div className={styles.loginLogoutBox}>
          <h1>מערכת ניהול הזמנות מתשתית בזק -
          שוק סיטונאי</h1>
          <AuthBox/>
        </div>
    );
};

export default LoginLogoutBox;
